var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M22.221 6.913a2.65 2.65 0 0 0-1.864-1.869c-1.644-.44-8.237-.44-8.237-.44s-6.59 0-8.236.44a2.65 2.65 0 0 0-1.865 1.87C1.579 8.56 1.579 12 1.579 12s0 3.44.44 5.087a2.65 2.65 0 0 0 1.865 1.87c1.646.44 8.236.44 8.236.44s6.593 0 8.237-.44a2.65 2.65 0 0 0 1.864-1.87c.44-1.647.44-5.087.44-5.087s0-3.44-.44-5.087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.014 15.171 5.477-3.17-5.477-3.171z"
  })));
};
export default SvgIconYoutube;